import Cookies from 'js-cookie'
import { jwtDecode } from 'jwt-decode'
import { logger } from './logger'
import { idToken } from './store-accessor'

// Record<string, string | number | boolean> へ代入可能にするため interface ではなく type で定義する
// （interface は暗黙の index signature を持たず captureException の引数型に代入できないため）
export type ErrorContext = {
  errorPage: string
  memNum: string
  zidSub: string
}

const UNKNOWN = 'unknown'

const getZidSub = (): string => {
  try {
    const token = idToken?.result?.idToken
    if (!token) {
      return UNKNOWN
    }
    const decoded = jwtDecode<{ sub?: string }>(token)
    return decoded.sub ?? UNKNOWN
  } catch {
    return UNKNOWN
  }
}

export const collectErrorContext = (): ErrorContext => {
  return {
    errorPage: typeof window !== 'undefined' ? window.location.pathname : UNKNOWN,
    memNum: Cookies.get('m_token') ?? UNKNOWN,
    zidSub: getZidSub(),
  }
}

export default class NewRelicErrorCaptureObject {
  captureException = (err: unknown, attrs: Record<string, string | number | boolean> = {}) => {
    try {
      if (
        typeof window === 'undefined' ||
        typeof window.newrelic === 'undefined' ||
        typeof window.newrelic.noticeError !== 'function'
      ) {
        return
      }
      const errorObj = err instanceof Error ? err : new Error(String(err ?? 'undefined error'))
      window.newrelic.noticeError(errorObj, { ...attrs })
    } catch (ex) {
      logger.warning('newrelic noticeError exception...')
      logger.error(ex)
    }
  }

  /**
   * EL_2ND-2763: NewRelic のアクション機能（addPageAction）でユーザー操作を記録する。
   * 会員番号などの共通コンテキスト（collectErrorContext）を自動付与し、
   * 呼び出し側から渡した attrs（押下ボタン・答案ID・コンテンツID など）をマージする。
   */
  recordPageAction = (actionName: string, attrs: Record<string, string | number | boolean> = {}) => {
    try {
      if (
        typeof window === 'undefined' ||
        typeof window.newrelic === 'undefined' ||
        typeof window.newrelic.addPageAction !== 'function'
      ) {
        return
      }
      window.newrelic.addPageAction(actionName, { ...collectErrorContext(), ...attrs })
    } catch (ex) {
      logger.warning('newrelic addPageAction exception...')
      logger.error(ex)
    }
  }
}

export const NewRelicErrorCapture = new NewRelicErrorCaptureObject()
